<template>
	<div class="shared-toggle">
		<div
			v-for="(item, index) in setup.options"
			:key="index"
			class="shared-toggle__toggle-item"
			:class="[
				{ 'shared-toggle__toggle-item--active' : item.label === setup.modelValue?.label },
				{ 'shared-toggle__toggle-item--with-counter' : item.counter !== undefined },
			]"
			@click="setup.modelValue = item">
			{{ item.label }}
			<div
				v-if="item.counter !== undefined"
				class="shared-toggle__toggle-item-counter">
				{{ item.counter }}
			</div>
		</div>
	</div>
</template>

<script setup lang="ts">
// #region Setup
import type { SharedToggleEmits, SharedToggleProps } from './SharedToggleSetup';
import SharedToggleSetup from './SharedToggleSetup';
const emits = defineEmits<SharedToggleEmits>() as SharedToggleEmits;
const props = withDefaults(defineProps<SharedToggleProps>(), SharedToggleSetup.defaultProps);
const setup = new SharedToggleSetup(props, emits);
// #endregion
</script>

<style lang="less" scoped>
.shared-toggle {
	display: flex;
	align-items: center;
	padding: 0.5rem;
	border-radius: 1.5rem;
	background-color: rgba(var(--rgb-grey-light), 0.5);

	&__toggle-item-counter {
		padding: 0 0.5rem;
		border-radius: 0.75rem;
		background-color: rgb(0 0 0 / 5%);
	}

	&__toggle-item {
		cursor: pointer;
		display: flex;
		gap: 0.25rem;
		padding: 0.25rem 1rem;
		border-radius: 1rem;
		font-weight: 600;
		color: var(--grey-dark);

		&--with-counter {
			padding-right: 0.25rem;
		}

		&--active {
			color: white;
			background: var(--info);
			box-shadow:
				0 0.125rem 0.125rem rgb(0 0 0 / 3%),
				0 0.25rem 0.25rem rgb(0 0 0 / 3%),
				0 0.5rem 0.5rem rgb(0 0 0 / 3%),
				0 1rem 1rem rgb(0 0 0 / 3%),
				0 2rem 2rem rgb(0 0 0 / 3%);

			.shared-toggle__toggle-item-counter {
				background-color: rgb(255 255 255 / 10%);
			}
		}
	}
}
</style>
